import {useSuspenseQuery} from '@tanstack/react-query';
import {annotationStatsSchema} from 'shared';

import {api} from '@/lib/ky';

import {annotationKeys} from './queryKeys';

import type {ExtractFnReturnType, QueryConfig} from '@/lib/react-query';

export const getAnnotationStats = async (projectId: QueryParams) => {
  const res = await api.get(`projects/${projectId}/stats`);
  const data = await res.json();

  return annotationStatsSchema.parse(data);
};

export const useAnnotationStats = (
  params: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: annotationKeys.stats(params),
    queryFn: () => getAnnotationStats(params),
  });
};

type QueryFnType = typeof getAnnotationStats;
type QueryParams = Parameters<typeof annotationKeys.stats>[0];
